import gql from 'graphql-tag';

import { Subscription } from 'core/subscription';

const CONTRIBUTIONS_SUBSCRIPTION = gql`
  subscription Contributions {
    contributions {
      title
      creator {
        profile {
          username
        }
      }
      project {
        slug
        space {
          spaceType
          content {
            slug
          }
        }
      }
    }
  }
`;

export class ContributionsSubscription extends Subscription {
  static conf = {
    GQL: CONTRIBUTIONS_SUBSCRIPTION,
    resultPath: 'contributions',
  };
}
